
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "AiMessage": [
      "AiMessageGuardian",
      "AiMessageSystem"
    ],
    "AiMessageTargetable": [
      "GuardianMessage",
      "LearningReport",
      "PlayerEffort",
      "PlayerTertiarySkillLevel"
    ],
    "BaseAiChatMessage": [
      "AiMessageGuardian",
      "AiMessageSystem"
    ],
    "BaseError": [
      "ApiError",
      "FileUploadNotFound",
      "GuardianTooManyError",
      "InvalidRequestError",
      "LimitExceededError",
      "MainSubscriptionIsNotActiveError",
      "OtherPlayerSubscriptionIsTrialing",
      "PasswordInvalid",
      "PlayerSubscriptionIsNotCanceled",
      "PlayerTooMany",
      "SubscriptionIsMainSubscriptionError",
      "TokenInvalid",
      "UserDoesNotHaveCurriculumLicenseError",
      "ValidationError",
      "VerificationCodeInvalid",
      "WrongEmailOrPassword"
    ],
    "BasePortfolioActivity": [
      "PortfolioActivityVirtualKoov"
    ],
    "BaseSchoolContent": [
      "CurriculumSchoolContent",
      "ExplSchoolContent",
      "SubscriptionSchoolContent"
    ],
    "BaseUser": [
      "SchoolUser",
      "User"
    ],
    "ChallengeParticipateError": [
      "ValidationError"
    ],
    "ChallengePlayerCreateError": [
      "PlayerTooMany",
      "ValidationError"
    ],
    "ChallengePlayerParticipateError": [
      "ValidationError"
    ],
    "ChallengeUserSignUpError": [
      "TokenInvalid",
      "ValidationError"
    ],
    "Coupon": [
      "AmountOffCoupon",
      "GiftCoupon",
      "PercentOffCoupon",
      "TrialCoupon"
    ],
    "CurrentUser": [
      "SchoolUser",
      "User"
    ],
    "DailyLearningParameterUpdateError": [
      "ValidationError"
    ],
    "EmailUpdateConfirmError": [
      "VerificationCodeInvalid"
    ],
    "EmptyPlayerCreateError": [
      "PlayerTooMany",
      "UserDoesNotHaveCurriculumLicenseError"
    ],
    "FreeTrialSignUpError": [
      "ValidationError"
    ],
    "GuardianCreateError": [
      "FileUploadNotFound",
      "GuardianTooManyError",
      "ValidationError"
    ],
    "GuardianMessageAiDraftCreateError": [
      "ApiError",
      "ValidationError"
    ],
    "GuardianMessageCreateError": [
      "ValidationError"
    ],
    "GuardianUpdateError": [
      "FileUploadNotFound",
      "ValidationError"
    ],
    "InitialPasswordSetupError": [
      "PasswordInvalid",
      "TokenInvalid"
    ],
    "LearningEvaluationActivity": [
      "AssessmentTestAttempt",
      "ContestAttempt"
    ],
    "LearningWork": [
      "ExplPlayerReport",
      "PlayerWork"
    ],
    "LicenseCodeActivateError": [
      "ValidationError"
    ],
    "Node": [
      "AiMessageGuardian",
      "AiMessageSystem",
      "AiSystemAnswerOption",
      "AiSystemChatAsset",
      "Assessment",
      "AssessmentTest",
      "AssessmentTestAttempt",
      "AssessmentTestReport",
      "Challenge",
      "Contest",
      "ContestAttempt",
      "ContestReport",
      "Curriculum",
      "CurriculumLicense",
      "CurriculumSchoolContent",
      "Distributor",
      "ExplPlayerReport",
      "ExplSchoolContent",
      "GeneratedImage",
      "Guardian",
      "Invoice",
      "Organization",
      "Player",
      "PlayerWork",
      "PortfolioActivityVirtualKoov",
      "PrimarySkill",
      "School",
      "SchoolGroup",
      "SchoolUser",
      "SecondarySkill",
      "SkillStep",
      "SubscriptionInfo",
      "SubscriptionSchoolContent",
      "Survey",
      "TertiarySkill",
      "User",
      "VirtualKoovLessonGroup"
    ],
    "PartnerUserSignUpWithPartnerCodeError": [
      "TokenInvalid",
      "ValidationError"
    ],
    "PasswordForgotConfirmError": [
      "LimitExceededError",
      "VerificationCodeInvalid"
    ],
    "PaymentMethod": [
      "CardPaymentMethod",
      "UnknownPaymentMethod"
    ],
    "PlayerUpdateError": [
      "ValidationError"
    ],
    "PlayerValidateError": [
      "ValidationError"
    ],
    "PortfolioActivity": [
      "PortfolioActivityVirtualKoov"
    ],
    "RewardItem": [
      "AvatarPartRewardItem",
      "CommentStampRewardItem",
      "FigureRewardItem"
    ],
    "SchoolContent": [
      "CurriculumSchoolContent",
      "ExplSchoolContent",
      "SubscriptionSchoolContent"
    ],
    "SchoolGuardianUserSignUpError": [
      "ApiError",
      "TokenInvalid",
      "ValidationError"
    ],
    "SchoolGuardianUserSignUpWithInviteTokenError": [
      "ApiError",
      "TokenInvalid",
      "ValidationError"
    ],
    "SchoolStudentBindError": [
      "ValidationError"
    ],
    "SchoolUserCheckError": [
      "ValidationError"
    ],
    "SignInTokenCreateError": [
      "ValidationError"
    ],
    "SignUpError": [
      "TokenInvalid",
      "ValidationError"
    ],
    "StripeSubscriptionCancelError": [
      "SubscriptionIsMainSubscriptionError"
    ],
    "StripeSubscriptionCreateError": [
      "InvalidRequestError",
      "OtherPlayerSubscriptionIsTrialing",
      "PlayerSubscriptionIsNotCanceled",
      "PlayerTooMany"
    ],
    "StripeSubscriptionCreateWithInviteTokenError": [
      "InvalidRequestError",
      "OtherPlayerSubscriptionIsTrialing",
      "PlayerSubscriptionIsNotCanceled",
      "PlayerTooMany"
    ],
    "StripeSubscriptionCreateWithPartnerCodeError": [
      "InvalidRequestError"
    ],
    "StripeSubscriptionPrecreateError": [
      "InvalidRequestError",
      "OtherPlayerSubscriptionIsTrialing",
      "PlayerSubscriptionIsNotCanceled",
      "PlayerTooMany"
    ],
    "StripeSubscriptionPrecreateWithInviteTokenError": [
      "InvalidRequestError",
      "OtherPlayerSubscriptionIsTrialing",
      "PlayerSubscriptionIsNotCanceled",
      "PlayerTooMany"
    ],
    "StripeSubscriptionPrecreateWithPartnerCodeError": [
      "InvalidRequestError"
    ],
    "StripeSubscriptionStopCancelError": [
      "MainSubscriptionIsNotActiveError"
    ],
    "SurveyResponseCreateError": [
      "ValidationError"
    ],
    "ValidationType": [
      "FormatValidation",
      "LengthValidation",
      "UniqueValidation"
    ]
  }
};
      export default result;
    